// extracted by mini-css-extract-plugin
export default {"modal":"adminModal_modal__6kiuu","login":"adminModal_login__8561z","password":"adminModal_password__gaEGF","btns":"adminModal_btns__VWi-s"};